module.exports = __webpack_public_path__ + "img/4-9.602f8784.png";